/**
 * Get user's full name from first_name and last_name
 * @param {Object} user - User object with first_name and last_name
 * @returns {string} Full name or fallback
 */
export function getFullName(user) {
  if (!user) return 'Unknown';
  const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim();
  // Prefer org contact email only when no name; never require platform email.
  return fullName || user.org_email || 'Unknown';
}

/**
 * Get user's initials from first_name and last_name
 * @param {Object} user - User object with first_name and last_name
 * @returns {string} Initials (e.g., "JD" for John Doe)
 */
export function getInitials(user) {
  if (!user) return '?';
  const first = user.first_name?.charAt(0) || '';
  const last = user.last_name?.charAt(0) || '';
  const initials = (first + last).toUpperCase();
  return initials || user.org_email?.charAt(0).toUpperCase() || '?';
}

